<template>
    <v-container fluid grid-list-xs>
        <v-layout v-if="petition" row wrap>

          <v-flex v-if="!petition.requested_team" xs12 sm10 offset-sm1>
              <team title="Equipo Solicitante" :players="petition.team_players" :infoTeam="petition.team" class="card-max-height"></team>
          </v-flex>
            <v-flex v-if="petition.requested_team" xs12 sm5 offset-sm1>
                <team title="Equipo Solicitante" :players="petition.team_players" :infoTeam="petition.team" class="card-max-height"></team>
            </v-flex>
            <v-flex v-if="petition.requested_team" xs12 sm5>
                <team v-if="petition.requested_team" title="Equipo Solicitado" :players="petition.requested_team_players" :infoTeam="petition.requested_team"></team>
            </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
    import Team from './Team'
    import Tournament from './Tournament'

    export default {
        name: "Partnering",
        props: {
            petition: {required: true},
            tournament:{required: true}
        },
        components: {
            Team,
            Tournament
        },
        data() {
            return {

            }
        }
    }
</script>

<style lang="css" scoped>
    .card-max-height {
        min-height: 650px
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/partnering/partnering.vue